<template>
  <main class="page-orderSys-config page-main__wrapper layout">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <div class="top-btns">
        <el-button @click="$_modify(-1)" class="btn__add">添加目录</el-button>
      </div>
      <el-form :inline="true" class="filter-form">
        <el-form-item label="目录类型:">
          <el-select v-model="filter.cataogType" placeholder="全部" style="width: 110px;">
            <el-option
              style="width: 110px;"
              v-for="item in filter.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上级目录:">
          <el-input v-model="filter.parentCatalog" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="目录名称:">
          <el-input v-model="filter.cataogName" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="序号:">
          <el-input v-model="filter.cataogSort" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$_reset" class="reset__btn">重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        v-loading="isLoading"
        border
        stripe
        tooltip-effect="dark"
      >
        <el-table-column label="操作" width="278" :resizable="false">
          <template slot-scope="scope">
            <cd-switch
              v-model="scope.row.showInDocument"
              @input="$_switch(scope.$index, scope.row)"
              :true-value="1"
              :false-value="0"
            >
              <span slot="open">显示</span>
              <span slot="close">隐藏</span>
            </cd-switch>
            <el-button class="edit__btn" @click="$_modify(scope.$index, scope.row)">编辑</el-button>
            <el-button class="delete__btn" @click="$_delete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
          v-if="!column.component"
        ></el-table-column>
        <el-table-column :prop="column.key" :label="column.label" :width="column.width" v-else>
          <template slot-scope="scope">
            <component :is="column.component" :row="scope.row"></component>
          </template>
        </el-table-column>
        <el-table-column></el-table-column>

        <div v-show="!isLoading" class="table-list__empty" slot="empty"></div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getConfigs"
      ></cd-pagination>
    </div>

    <modal-modify
      v-if="modal.show && modal.template === 'modify'"
      :title="modal.title"
      :formType="modal.type"
      :modalData="modal.data"
      @callback="$_callback"
      @close="$_close"
    ></modal-modify>
  </main>
</template>

<script>
import resize from "@/mixins/resize";
import ModalModify from "./modal-modify";

const columns = [
  { key: "cataogType", label: "目录类型", width: 120, component: "cataogTpl" },
  { key: "cataogName", label: "目录名称", width: 120 },
  { key: "parentName", label: "上级目录", width: 120 },
  { key: "catalogProperties", label: "目录属性", width: 140, component: "cataogPropTpl" },
  { key: "cataogSort", label: "序号", width: 120 },
  { key: "creatorName", label: "创建人", width: 120 },
  { key: "createTime", label: "创建时间", width: 160 },
  { key: "operatorName", label: "最后编辑人", width: 120 },
  { key: "updateTime", label: "最后编辑时间", width: 160 }
];

export default {
  name: "docs-catalogue",
  mixins: [resize],
  data() {
    return {
      isLoading: false,
      tpm: true,
      filter: {
        cataogSort: "",
        parentCatalog: "", //父级目录
        cataogName: "", //目录名称
        cataogType: 0, //目录类型
        options: [
          {
            value: 0,
            label: "全部"
          },
          {
            value: 1,
            label: "接口目录"
          },
          {
            value: 2,
            label: "公告说明目录"
          },
          {
            value: 3,
            label: "接口指引目录"
          }
        ]
      },
      tableHeight: null,
      dataList: [],
      columns,
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      },
      modal: {
        show: false,
        title: "",
        template: "",
        type: "",
        data: {}
      }
    };
  },

  methods: {
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      let reg = /[^\d.]/g;
      if(this.filter.cataogSort && new RegExp(reg).test(this.filter.cataogSort)){
         $MessageBox.alert({
          content: `
            <div>序号需填数字！</div>
          `,
        });
      }else{
         this.$_getConfigs();
      }
    },
    // 重置
    $_reset() {
      this.filter.parentCatalog = "";
      this.filter.cataogName = "";
      this.filter.cataogType = 0;
      this.filter.cataogSort = "";
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getConfigs();
    },
    // 查询应用配置列表
    $_getConfigs() {
      this.isLoading = true;
      this.$refs.tableList.clearSort();
      const postData = {
        cataogSort: this.filter.cataogSort || this.cataogSort,
        cataogType: this.filter.cataogType,
        cataogName: this.filter.cataogName,
        parentCatalog: this.filter.parentCatalog,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize
      };
      this.$service.post("queryCatalogPaging", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getConfigs();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getConfigs();
    },
    // 启用/停用
    $_switch($index, row) {
      const self = this;
      const callback = (content) => {
        $MessageBox.alert({
          content,
          onOk() {
            self.$_getConfigs()
          },
        });
      };
      if (row.showInDocument === 1) {
        // 停用切换成启用
        self.$service
          .post("showInDocument", {
            cid: row.cid,
            showInDocument: 1,
          })
          .then((result) => {
            if (result.$.checkResult(result, true)) {
              callback(result.msg);
            } else {
              self.dataList[$index].showInDocument = 0;
            }
          });
      } else if (row.showInDocument === 0) {
        // 启用切换成停用
        $MessageBox.confirm({
          content: `
            <div>是否停用当前的目录?</div>
          `,
          onOk() {
            self.$service
              .post("showInDocument", {
                cid: row.cid,
                showInDocument: 0,
              })
              .then((result) => {
                if (result.$.checkResult(result, true)) {
                  callback(result.msg);
                } else {
                  self.dataList[$index].showInDocument = 1;
                }
              });
          },
          onCancel() {
            if (row.showInDocument === 0) {
              self.dataList[$index].showInDocument = 1;
            }
          },
        });
      }
    },
    // 更新品牌状态 - 1-启用/2-停用/3-删除
    $_delete(row) {
      const self = this;
      let content = "是否删除当前选项?";
      let cid = [row.cid];
      $MessageBox.confirm({
        content,
        onOk() {
          self.$service
            .post("updateCatalogStatus", {
              cid,
              status: 3
            })
            .then(result => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.$_getConfigs();
                  }
                });
              }
            });
        }
      });
    },

    $_modify($index, row) {
      this.isLoading = true;
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "新增目录";
      if ($index !== -1) {
        this.modal.type = "edit";
        this.modal.title = "编辑目录";
        this.modal.data = JSON.parse(JSON.stringify(row));
      }
      this.modal.template = "modify";
      this.modal.show = true;
      this.isLoading = false;
    },
    // 新增/编辑配置成功回调
    $_callback() {
      this.$_close();
      this.$_getConfigs();
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "";
    }
  },

  components: {
    ModalModify,
    cataogTpl: {
      template: `<span>{{row.cataogType === 1 ? '接口目录': row.cataogType === 2 ? '公告说明目录' : '接口指引目录'}}</span>`,
      props: { row: { type: Object, require: true } }
    },
    cataogPropTpl: {
      data(){
        return {
          names: {
            1: '对内文档', 
            2: '对外标准'
          }
        }
      },
      template: `<span>{{row.catalogProperties && row.catalogProperties.map(item => this.names[item]).join(',')}}</span>`,
      props: { row: { type: Object, require: true } }
    }
  },
  async mounted() {
    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
    this.$_getConfigs();
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
}

.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;

  .top-btns {
    min-height: 40px;
  }

  .filter-form {
    .autocomplete-box {
      display: inline-block;
      position: relative;
      width: 110px;
      .autocomplete-empty {
        padding: 10px;
        margin: 0;
        color: #535353;
        width: 100%;
      }
    }
    .el-form-item {
      margin-top: 12px;
    }
  }
}

.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
}
</style>


